import React from 'react';
import {IndexLink, Link, withRouter} from 'react-router';
import Textarea from 'react-textarea-autosize';
import axios from 'axios';
var querystring = require('querystring');
import {isMobile} from 'react-device-detect';
import * as commonApi from '../../../api/common-api';

const file_limit = 25*1024*1024;
const file_count = 10;

class ChallengeSubmit extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            name_company: '',
            filesArr: [],
            filesStr: '',
            files: [],
            application: 0,
            message: '',
            is_submiting: false,
            lableSubmit: "Submit challenge"
        }
    }

    componentWillMount = () => {}

    componentDidMount = () => {
        this.setState(Object.assign({}, this.props.params));
    }

    componentWillReceiveProps = (nextProps) => {}

    handleMessageChange = (e) => {
        this.setState({message: e.target.value});
    }

    handleAttClick = (event) => {
        this.refs.file_input.value = '';
        this.refs.file_input.click();
    }

    handleFileUpload = (event) => {
        var files = this.state.files;

        if (files.length > file_count) {
            commonApi.showAlert("You only may attach up to 10 files.");
            this.refs.file_input.value = '';
            return false;
        }

        if (event.target.files.length > 0) {

            var fileUpload = event.target.files[0];
            if (fileUpload.size > file_limit) {
                commonApi.showAlert("Max file size is 25MB!");
                this.refs.file_input.value = '';
                return;
            }
            var Extension = fileUpload.name.substring(fileUpload.name.lastIndexOf('.') + 1).toLowerCase();
            var allowedExtensions = ['xlsx', 'xls', 'doc', 'docx', 'ppt', 'pptx', 'txt', 'pdf', 'zip', 'rar', '7z', 'rtf'];
            var imageExt = ['jpg', 'jpeg', 'png', 'bmp', 'gif'];

            if (imageExt.indexOf(Extension) !== -1 || Extension !== '') {
                var data = new FormData();
                data.append('file', fileUpload);
                axios.post('/code/api_experiences.php?api=uploadExperiential',data)
                    .then(response => {
                        if(parseInt(response.data.status) === 1)
                        {
                            files.push(response.data.data)
                            this.setState({files: files}, () => {
                                this.renderFilesAttach()
                            });
                        }
                        else {
                            commonApi.showAlert(response.data.message);
                        }
                    });
            }
            else {
                commonApi.showAlert("Only accept: documents, images, compress files");
                this.refs.file_input.value = '';
            }
        }
    }

    handleFileDel = (file, e) => {
        let files = this.state.files
        var file_reset = []
        for (var item of files) {
            if (parseInt(item.id_file) !== parseInt(file)) {
                file_reset.push(item);
            }
        }
        this.setState({files: file_reset}, () => {
            this.renderFilesAttach()
        })
    }

    renderFilesAttach = () => {
        let files = this.state.files
        let filesStr = ''
        var filesArr = []
        for (var item of files) {
            filesStr += item.id_file + ","
            filesArr.push(
                <div key={"files-" + item.id_file} className="col-sm-12 text-left mrb-10 attach-area">
                    <div className="img"><img src="/static/img/appimg/icons-attach.png"/></div>
                    <span>{item.name_file}</span>
                    <span onClick={this.handleFileDel.bind(this, item.id_file)} className="glyphicon glyphicon-trash">&nbsp;</span>
                </div>
            )
        }
        this.setState({filesArr: filesArr, filesStr: filesStr})
    }

    // handlePostClick = () => {
    //     if (this.state.is_submiting === false) {
    //         this.setState({is_submiting: true, lableSubmit: "Processing" });
    //         let url = "/code/api_experiences.php?api=updateProjectTask";
    //         var params = Object.assign({},
    //             this.state.files,
    //             {
    //                 id_joined: joined,
    //                 act: 'submit',
    //                 msg: this.state.message,
    //             }
    //         )
    //         axios.post(url, querystring.stringify(params))
    //             .then(response => {
    //                 var rst_response = response.data;
    //                 if (parseInt(rst_response.status) === 1) {
    //                     this.props.handleUpdChallenge()
    //                 } else {
    //                     this.setState({is_submiting: false});
    //                     commonApi.showAlert(rst_response.message);
    //                 }
    //             });
    //     }
    // }

    handlePostSubmitWorkClick = (e) => {
        if (this.state.isSubmited === true) {
            return false;
        }
        this.setState({ isSubmited: true, lableSubmit: "Processing" })
        let url = "/code/api_experiences.php?api=updateProjectTask";
        var params = Object.assign({},
            {
                id_file: this.state.filesStr,
                act: 'submit',
                msg: this.state.message,
                id_project: this.props.id_project
            }
        )
        axios.post(url, querystring.stringify(params))
            .then(response => {
                let rst = response.data;
                let rst_data = rst.data;

                if (parseInt(rst.status) === 1) {
                    this.props.handleUpdChallenge(rst_data.tasks)
                }
                else {
                    commonApi.showAlert("There was an error. Please try again");
                }
            }).catch(error => {
        });
    }

    closeModal = () => {
        this.props.closeModalChallenge()
    }

    render() {
        return (
            <div id="submit-and-request" className={isMobile ? "submit-and-request-mobile" : ""}>
                <div className={"items headding"}>
                    <div className={"title"}>Submit Challenge to {this.state.name_company}</div>
                    <button className="close" onClick={this.closeModal.bind(this)}>X</button>
                </div>
                <div className={"items contents form-horizontal"}>
                    <div className="form-group">
                        <label className="control-label col-sm-12 text-left mrb-10" htmlFor="pwd">Cover letter</label>
                        <div className="col-sm-12">
                            <Textarea
                                name="message"
                                className={"form-control"}
                                maxRows={10}
                                minRows={10}
                                value={this.state.message}
                                onChange={this.handleMessageChange.bind(this)}
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <label className="control-label col-sm-12 text-left mrb-10" htmlFor="pwd">Attachments</label>
                        {this.state.filesArr}
                        <div className="col-sm-12 txt-lab">
                            <span className="upd-area">
                                drag or <a onClick={this.handleAttClick.bind(this)}>upload</a> project files
                            </span>
                            <input ref="file_input"
                                   className="hide-el"
                                   type="file"
                                   onChange={this.handleFileUpload.bind(this)}/>
                            <span className="t-lab-b ptb70 txt-rec">
                                You may attach up to 10 files under the size of 25MB each. Include work drag or upload challenge files or other documents to support challenge application.
                                Do not attach your resume - Your Versity profile is automatically forwarded to the client with your proposal.
                            </span>
                        </div>
                    </div>
                </div>
                <div className="form-group footer">
                    <div className="col-sm-offset-2 col-sm-10 text-right">
                        <a onClick={this.handlePostSubmitWorkClick.bind(this)} className="btn_v btn_confirm">{this.state.lableSubmit}</a>
                    </div>
                </div>
            </div>
        )
    }
}

ChallengeSubmit.propTypes = {
    router: React.PropTypes.shape({
        push: React.PropTypes.func.isRequired
    }).isRequired
};

export default withRouter(ChallengeSubmit);


/** WEBPACK FOOTER **
 ** ./src/client/app/appcomponents/commons/challenge-experiential/challenge-submit.js
 **/